// // import React, { useState, useEffect, useRef } from "react";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import QuestionDisplay from "./components/QuestionDisplay";
// // import CodeEditor from "./components/CodeEditor";
// // import VoiceAssistant from "./components/VoiceAssistant";
// // import VoiceControls from "./components/VoiceControls";
// // import { useSpeechRecognition } from "./hooks/useSpeechRecognition";
// // import api from "../../../api/axiosInstance";

// // const ActiveInterviewSession = () => {

// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   /* ===============================
// //      SAFE STATE HANDLING
// //   =============================== */

// //   const position = location.state?.position || "Software Engineer";
// //   const techStack = location.state?.techStack || ["JavaScript"];
// //   const experience = location.state?.experience || "0";

// //   const [sessionId, setSessionId] = useState(null);
// //   const [currentQuestion, setCurrentQuestion] = useState(null);
// //   const [questionType, setQuestionType] = useState("question");
// //   const [openEditor, setOpenEditor] = useState(false);
// //   const [isSpeaking, setIsSpeaking] = useState(false);
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   const hasStartedRef = useRef(false);

// //   /* ===============================
// //      🎤 SPEECH HOOK
// //   =============================== */

// //   const {
// //     isRecording,
// //     transcript,
// //     language,
// //     setLanguage,
// //     startRecording,
// //     stopRecording,
// //     resetTranscript,
// //   } = useSpeechRecognition();

// //   const [userAnswer, setUserAnswer] = useState("");

// //   useEffect(() => {
// //     setUserAnswer(transcript);
// //   }, [transcript]);

// //   /* ===============================
// //      🔒 BLOCK PAGE EXIT
// //   =============================== */

// //   useEffect(() => {

// //     const handleBeforeUnload = (e) => {
// //       e.preventDefault();
// //       e.returnValue = "";
// //     };

// //     window.addEventListener("beforeunload", handleBeforeUnload);

// //     return () =>
// //       window.removeEventListener("beforeunload", handleBeforeUnload);

// //   }, []);

// //   /* ===============================
// //      🚀 START INTERVIEW SESSION
// //   =============================== */

// //   useEffect(() => {

// //     if (hasStartedRef.current) return;

// //     hasStartedRef.current = true;

// //     const startSession = async () => {

// //       try {

// //         console.log("Starting interview with:", {
// //           position,
// //           techStack,
// //           experience
// //         });

// //         const res = await api.post("/api/interview/start", {
// //           position: position || "Software Engineer",
// //           selectedTechStack: techStack || [],
// //           experience: experience || "0"
// //         });

// //         console.log("Session created:", res.data);

// //         setSessionId(res.data._id);

// //         fetchNextQuestion(res.data._id, "");

// //       } catch (err) {

// //         console.error(
// //           "Start session error:",
// //           err.response?.data || err.message
// //         );

// //       }
// //     };

// //     startSession();

// //   }, []);

// //   /* ===============================
// //      🔁 FETCH NEXT QUESTION
// //   =============================== */

// //   const fetchNextQuestion = async (id, answer) => {

// //     try {

// //       const res = await api.post("/api/interview/next", {
// //         sessionId: id || sessionId,
// //         candidateAnswer: answer,
// //       });

// //       if (res.data.type === "end") {

// //         navigate("/candidate/interview-results-hub");

// //         return;
// //       }

// //       setCurrentQuestion(res.data.question);
// //       setQuestionType(res.data.type);
// //       setOpenEditor(res.data.openEditor);

// //       resetTranscript();

// //     } catch (err) {

// //       console.error(
// //         "Next question error:",
// //         err.response?.data || err.message
// //       );

// //     }
// //   };

// //   /* ===============================
// //      🔊 AI SPEAK QUESTION
// //   =============================== */

// //   useEffect(() => {

// //     if (!currentQuestion) return;

// //     const synth = window.speechSynthesis;

// //     synth.cancel();

// //     const utterance = new SpeechSynthesisUtterance(currentQuestion);

// //     utterance.lang = language;
// //     utterance.rate = 1;

// //     utterance.onstart = () => setIsSpeaking(true);
// //     utterance.onend = () => setIsSpeaking(false);
// //     utterance.onerror = () => setIsSpeaking(false);

// //     setTimeout(() => {

// //       synth.speak(utterance);

// //     }, 300);

// //   }, [currentQuestion, language]);

// //   /* ===============================
// //      🎤 START RECORDING
// //   =============================== */

// //   const handleStartRecording = () => {

// //     if (isSpeaking || isSubmitting) return;

// //     resetTranscript();

// //     startRecording();

// //   };

// //   /* ===============================
// //      ✅ SUBMIT ANSWER
// //   =============================== */

// //   const handleSubmitResponse = async () => {

// //     if (!userAnswer.trim() || isSubmitting) return;

// //     setIsSubmitting(true);

// //     stopRecording();

// //     await fetchNextQuestion(null, userAnswer);

// //     setIsSubmitting(false);

// //   };

// //   /* ===============================
// //      💻 SUBMIT CODE
// //   =============================== */

// //   const handleSubmitCode = async (code, lang) => {

// //     if (isSubmitting) return;

// //     setIsSubmitting(true);

// //     try {

// //       await api.post("/api/interview/evaluate-code", {
// //         sessionId,
// //         question: currentQuestion,
// //         code,
// //         language: lang,
// //       });

// //       setOpenEditor(false);

// //       await fetchNextQuestion(null, code);

// //     } catch (err) {

// //       console.error(
// //         "Code submit error:",
// //         err.response?.data || err.message
// //       );

// //     }

// //     setIsSubmitting(false);

// //   };

// //   /* ===============================
// //      ⏳ LOADING SCREEN
// //   =============================== */

// //   if (!currentQuestion || !sessionId) {

// //     return (
// //       <div className="flex items-center justify-center min-h-screen">
// //         Starting Technical Interview...
// //       </div>
// //     );

// //   }

// //   /* ===============================
// //      UI
// //   =============================== */

// //   return (

// //     <div className="min-h-screen bg-background flex flex-col justify-center items-center px-4">

// //       {/* Language Selector */}
// //       <div className="mb-4">

// //         <select
// //           value={language}
// //           onChange={(e) => setLanguage(e.target.value)}
// //           className="border px-3 py-2 rounded-md"
// //         >

// //           <option value="en-IN">English (India)</option>
// //           <option value="en-US">English (US)</option>
// //           <option value="hi-IN">Hindi</option>
// //           <option value="ta-IN">Tamil</option>
// //           <option value="te-IN">Telugu</option>
// //           <option value="mr-IN">Marathi</option>
// //           <option value="kn-IN">Kannada</option>

// //         </select>

// //       </div>

// //       <div className="mb-6 text-sm font-semibold text-gray-500 uppercase tracking-wide">

// //         {questionType === "coding"
// //           ? "Coding Round"
// //           : "Technical Round"}

// //       </div>

// //       <div className="w-full max-w-3xl">

// //         <QuestionDisplay
// //           question={currentQuestion}
// //           questionType={questionType}
// //         />

// //         <VoiceAssistant
// //           isListening={isRecording}
// //           isSpeaking={isSpeaking}
// //         />

// //         {openEditor ? (

// //           <CodeEditor onSubmitCode={handleSubmitCode} />

// //         ) : (

// //           !isSpeaking && (

// //             <VoiceControls
// //               isRecording={isRecording}
// //               onStartRecording={handleStartRecording}
// //               onStopRecording={stopRecording}
// //               onSubmitResponse={handleSubmitResponse}
// //               transcription={userAnswer}
// //               canSubmit={userAnswer.length > 5}
// //               isSubmitting={isSubmitting}
// //             />

// //           )

// //         )}

// //       </div>

// //     </div>

// //   );

// // };

// // export default ActiveInterviewSession;

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import QuestionDisplay from "./components/QuestionDisplay";
// import CodeEditor from "./components/CodeEditor";
// import VoiceAssistant from "./components/VoiceAssistant";
// import VoiceControls from "./components/VoiceControls";
// import { useSpeechRecognition } from "./hooks/useSpeechRecognition";
// import api from "../../../api/axiosInstance";

// const ActiveInterviewSession = () => {

//   const navigate = useNavigate();
//   const location = useLocation();

//   const position = location.state?.position || "Software Engineer";
//   const techStack = location.state?.techStack || ["JavaScript"];
//   const experience = location.state?.experience || "0";

//   const [sessionId, setSessionId] = useState(null);
//   const [currentQuestion, setCurrentQuestion] = useState(null);
//   const [questionType, setQuestionType] = useState("question");
//   const [openEditor, setOpenEditor] = useState(false);
//   const [isSpeaking, setIsSpeaking] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [userAnswer, setUserAnswer] = useState("");

//   const hasStartedRef = useRef(false);

//   const {
//     isRecording,
//     transcript,
//     language,
//     setLanguage,
//     startRecording,
//     stopRecording,
//     resetTranscript
//   } = useSpeechRecognition();

//   useEffect(() => {
//     if (transcript) setUserAnswer(transcript);
//   }, [transcript]);

//   /* -----------------------------
//       START INTERVIEW
//   ------------------------------ */

//   useEffect(() => {

//     if (hasStartedRef.current) return;
//     hasStartedRef.current = true;

//     const startSession = async () => {

//       try {

//         console.log("Starting interview with:", {
//           position,
//           techStack,
//           experience
//         });

//         const res = await api.post("/api/interview/start", {
//           position,
//           selectedTechStack: techStack,
//           experience
//         });

//         console.log("Session created:", res.data);

//         setSessionId(res.data._id);

//         fetchNextQuestion(res.data._id, "");

//       } catch (err) {

//         console.error("Start session error:",
//           err.response?.data || err.message
//         );

//       }

//     };

//     startSession();

//   }, []);

//   /* -----------------------------
//       FETCH NEXT QUESTION
//   ------------------------------ */

//   const fetchNextQuestion = async (id, answer) => {

//     try {

//       const res = await api.post("/api/interview/next", {
//         sessionId: id || sessionId,
//         candidateAnswer: answer
//       });

//       console.log("Next question response:", res.data);

//       if (res.data.type === "end") {

//         navigate("/candidate/interview-results-hub");
//         return;

//       }

//       setCurrentQuestion(res.data.question);
//       setQuestionType(res.data.type);
//       setOpenEditor(res.data.openEditor);

//       resetTranscript();
//       setUserAnswer("");

//     } catch (err) {

//       console.error("Next question error:",
//         err.response?.data || err.message
//       );

//     }

//   };

//   /* -----------------------------
//       SPEECH OUTPUT
//   ------------------------------ */

//   useEffect(() => {

//     if (!currentQuestion) return;

//     const synth = window.speechSynthesis;
//     synth.cancel();

//     const utterance = new SpeechSynthesisUtterance(currentQuestion);

//     utterance.lang = language;
//     utterance.rate = 1;

//     utterance.onstart = () => setIsSpeaking(true);

//     utterance.onend = () => {
//       setIsSpeaking(false);
//     };

//     utterance.onerror = () => {
//       setIsSpeaking(false);
//     };

//     synth.speak(utterance);

//     // fallback safety
//     setTimeout(() => setIsSpeaking(false), 4000);

//   }, [currentQuestion]);

//   /* -----------------------------
//       SUBMIT ANSWER
//   ------------------------------ */

//   const handleSubmitResponse = async () => {

//     if (!userAnswer.trim() || isSubmitting) return;

//     setIsSubmitting(true);

//     stopRecording();

//     await fetchNextQuestion(null, userAnswer);

//     setIsSubmitting(false);

//   };

//   /* -----------------------------
//       SUBMIT CODE
//   ------------------------------ */

//   const handleSubmitCode = async (code, lang) => {

//     if (isSubmitting) return;

//     setIsSubmitting(true);

//     try {

//       await api.post("/api/interview/evaluate-code", {
//         sessionId,
//         question: currentQuestion,
//         code,
//         language: lang
//       });

//       setOpenEditor(false);

//       await fetchNextQuestion(null, code);

//     } catch (err) {

//       console.error("Code submit error:",
//         err.response?.data || err.message
//       );

//     }

//     setIsSubmitting(false);

//   };

//   /* -----------------------------
//       LOADING STATE
//   ------------------------------ */

//   if (!currentQuestion || !sessionId) {

//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         Starting Technical Interview...
//       </div>
//     );

//   }

//   /* -----------------------------
//       UI
//   ------------------------------ */

//   return (

//     <div className="min-h-screen flex flex-col items-center p-6">

//       <select
//         value={language}
//         onChange={(e) => setLanguage(e.target.value)}
//       >
//         <option value="en-IN">English (India)</option>
//         <option value="en-US">English (US)</option>
//       </select>

//       <h3 className="mt-4 text-gray-500">
//         {questionType === "coding" ? "Coding Round" : "Technical Round"}
//       </h3>

//       <div className="w-full max-w-3xl">

//         <QuestionDisplay
//           question={currentQuestion}
//           questionType={questionType}
//         />

//         <VoiceAssistant
//           isListening={isRecording}
//           isSpeaking={isSpeaking}
//         />

//         {/* TEXT INPUT (IMPORTANT FOR DEBUGGING) */}
//         {!openEditor && (
//           <textarea
//             className="w-full border rounded p-2 mt-4"
//             placeholder="Type your answer here..."
//             value={userAnswer}
//             onChange={(e) => setUserAnswer(e.target.value)}
//           />
//         )}

//         {openEditor ? (

//           <CodeEditor onSubmitCode={handleSubmitCode} />

//         ) : (

//           <VoiceControls
//             isRecording={isRecording}
//             onStartRecording={startRecording}
//             onStopRecording={stopRecording}
//             onSubmitResponse={handleSubmitResponse}
//             transcription={userAnswer}
//             canSubmit={userAnswer.length > 3}
//             isSubmitting={isSubmitting}
//           />

//         )}

//       </div>

//     </div>

//   );

// };

// export default ActiveInterviewSession;


// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import api from "../../../api/axiosInstance";

// const ActiveInterviewSession = () => {

//   const navigate = useNavigate();
//   const location = useLocation();

//   const position = location.state?.position || "Software Engineer";
//   const techStack = location.state?.techStack || ["JavaScript"];
//   const experience = location.state?.experience || "0";

//   const [sessionId, setSessionId] = useState(null);
//   const [chatHistory, setChatHistory] = useState([]);
//   const [userAnswer, setUserAnswer] = useState("");
//   const [seconds, setSeconds] = useState(0);
//   const [isSpeaking, setIsSpeaking] = useState(false);

//   const hasStartedRef = useRef(false);

//   /* =============================
//      TIMER
//   ============================= */

//   useEffect(() => {

//     const timer = setInterval(() => {
//       setSeconds((prev) => prev + 1);
//     }, 1000);

//     return () => clearInterval(timer);

//   }, []);

//   const formatTime = () => {

//     const m = Math.floor(seconds / 60);
//     const s = seconds % 60;

//     return `${m}:${s < 10 ? "0" : ""}${s}`;

//   };

//   /* =============================
//      SPEAK QUESTION
//   ============================= */

//   const speak = (text) => {

//     const synth = window.speechSynthesis;

//     if (!synth) return;

//     synth.cancel();

//     const utterance = new SpeechSynthesisUtterance(text);

//     utterance.lang = "en-US";
//     utterance.rate = 1;

//     utterance.onstart = () => setIsSpeaking(true);
//     utterance.onend = () => setIsSpeaking(false);
//     utterance.onerror = () => setIsSpeaking(false);

//     synth.speak(utterance);

//   };

//   /* =============================
//      START INTERVIEW
//   ============================= */

//   useEffect(() => {

//     if (hasStartedRef.current) return;

//     hasStartedRef.current = true;

//     const startSession = async () => {

//       try {

//         const res = await api.post("/api/interview/start", {
//           position,
//           selectedTechStack: techStack,
//           experience
//         });

//         setSessionId(res.data._id);

//         fetchNextQuestion(res.data._id, "");

//       } catch (err) {

//         console.error("Start session error",
//           err.response?.data || err.message
//         );

//       }

//     };

//     startSession();

//   }, []);

//   /* =============================
//      NEXT QUESTION
//   ============================= */

//   const fetchNextQuestion = async (id, answer) => {

//     try {

//       const res = await api.post("/api/interview/next", {
//         sessionId: id || sessionId,
//         candidateAnswer: answer
//       });

//       if (res.data.type === "end") {
//         navigate("/candidate/interview-results-hub");
//         return;
//       }

//       const question = res.data.question;

//       setChatHistory((prev) => [
//         ...prev,
//         { role: "assistant", text: question }
//       ]);

//       speak(question);

//       setUserAnswer("");

//     } catch (err) {

//       console.error("Next question error",
//         err.response?.data || err.message
//       );

//     }

//   };

//   /* =============================
//      SUBMIT ANSWER
//   ============================= */

//   const submitAnswer = async () => {

//     if (!userAnswer.trim()) return;

//     setChatHistory((prev) => [
//       ...prev,
//       { role: "user", text: userAnswer }
//     ]);

//     await fetchNextQuestion(null, userAnswer);

//   };

//   /* =============================
//      UI
//   ============================= */

//   return (

//     <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">

//       <div className="w-full max-w-3xl flex justify-between mb-4">

//         <h2 className="text-xl font-semibold">
//           AI Technical Interview
//         </h2>

//         <div className="text-sm text-gray-500">
//           Time: {formatTime()}
//         </div>

//       </div>

//       <div className="w-full max-w-3xl bg-white rounded-xl shadow p-6">

//         {/* INTERVIEWER */}

//         <div className="flex items-center gap-3 mb-6">

//           <img
//             src="https://randomuser.me/api/portraits/men/32.jpg"
//             className="w-12 h-12 rounded-full"
//           />

//           <div>

//             <div className="font-semibold">
//               Senior Software Engineer
//             </div>

//             <div className="text-sm text-gray-500">
//               Technical Interviewer
//             </div>

//           </div>

//           {isSpeaking && (
//             <div className="ml-auto text-green-600 text-sm animate-pulse">
//               Speaking...
//             </div>
//           )}

//         </div>

//         {/* CHAT HISTORY */}

//         <div className="h-72 overflow-y-auto border rounded-lg p-4 mb-4">

//           {chatHistory.map((msg, i) => (

//             <div key={i} className="mb-3">

//               <div className="text-xs text-gray-500">

//                 {msg.role === "assistant"
//                   ? "Interviewer"
//                   : "You"}

//               </div>

//               <div className="bg-gray-100 rounded p-2">

//                 {msg.text}

//               </div>

//             </div>

//           ))}

//         </div>

//         {/* ANSWER */}

//         <textarea
//           placeholder="Type your answer here..."
//           value={userAnswer}
//           onChange={(e) => setUserAnswer(e.target.value)}
//           className="w-full border rounded-lg p-3 mb-4"
//         />

//         <button
//           onClick={submitAnswer}
//           className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
//         >
//           Submit Answer
//         </button>

//       </div>

//     </div>

//   );

// };

// export default ActiveInterviewSession;


import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../../api/axiosInstance";

const ActiveInterviewSession = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const position = location.state?.position || "Software Engineer";
  const techStack = location.state?.techStack || ["JavaScript"];
  const experience = location.state?.experience || "0";

  const [sessionId, setSessionId] = useState(null);
  const [chatHistory, setChatHistory] = useState([]);
  const [userAnswer, setUserAnswer] = useState("");
  const [seconds, setSeconds] = useState(0);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [showEndPopup, setShowEndPopup] = useState(false);

  const hasStartedRef = useRef(false);
  const recognitionRef = useRef(null);
  const sessionIdRef = useRef(null);



  /* =============================
     TIMER
  ============================= */
  useEffect(() => {
    const timer = setInterval(() => setSeconds((p) => p + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  /* =============================
     SPEECH SYNTHESIS (AI SPEAKS)
  ============================= */
  const speak = (text) => {
    const synth = window.speechSynthesis;
    if (!synth) return;

    synth.cancel();

    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = "en-US";
    utter.rate = 1;

    utter.onstart = () => setIsSpeaking(true);
    utter.onend = () => setIsSpeaking(false);
    utter.onerror = () => setIsSpeaking(false);

    synth.speak(utter);
  };

  /* =============================
     SPEECH RECOGNITION (USER)
  ============================= */
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      console.warn("Speech recognition not supported");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.continuous = false;

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setUserAnswer(transcript);
      setIsRecording(false);
    };

    recognition.onerror = () => setIsRecording(false);

    recognitionRef.current = recognition;
  }, []);

  const startRecording = () => {
    if (!recognitionRef.current) return;
    setIsRecording(true);
    recognitionRef.current.start();
  };

  const stopRecording = () => {
    if (!recognitionRef.current) return;
    recognitionRef.current.stop();
    setIsRecording(false);
  };

  /* =============================
     START INTERVIEW
  ============================= */
  useEffect(() => {
    console.log("Component mounted — starting session");

    const startSession = async () => {
      try {
        console.log("Calling /api/interview/start with:", {
          position,
          selectedTechStack: techStack,
          experience,
        });

        const res = await api.post("/api/interview/start", {
          position,
          selectedTechStack: techStack,
          experience,
        });

        console.log("Session created:", res.data._id);

        setSessionId(res.data._id);
        sessionIdRef.current = res.data._id;
        fetchNextQuestion(res.data._id, "");
      } catch (err) {
        console.error("Start session error", err.response?.data || err.message);
      }
    };

    startSession();
  }, []); // ← empty array means runs once on mount

  /* =============================
     NEXT QUESTION
  ============================= */
  const fetchNextQuestion = async (id, answer) => {
    try {
      const res = await api.post("/api/interview/next", {
        sessionId: id || sessionId,
        candidateAnswer: answer,
      });

      if (res.data.type === "end" || res.data.showPopup) {

        const question = res.data.question;

        // show final message in chat
        setChatHistory((prev) => [
          ...prev,
          { role: "assistant", text: question }
        ]);

        speak(question);

        // show popup after small delay (feels real)
        setTimeout(() => {
          setShowEndPopup(true);
        }, 1500);

        return;
      }

      const question = res.data.question;

      setChatHistory((prev) => [...prev, { role: "assistant", text: question }]);

      speak(question);
      setUserAnswer("");
    } catch (err) {
      console.error("Next question error", err.response?.data || err.message);
    }
  };

  /* =============================
     SUBMIT ANSWER
  ============================= */
  const submitAnswer = async () => {
    if (!userAnswer.trim()) return;

    setChatHistory((prev) => [...prev, { role: "user", text: userAnswer }]);
    await fetchNextQuestion(null, userAnswer);
  };

  /* =============================
     UI
  ============================= */
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
      <div className="w-full max-w-3xl flex justify-between mb-4">
        <h2 className="text-xl font-semibold">AI Technical Interview</h2>
        <div className="text-sm text-gray-500">Time: {formatTime()}</div>
      </div>

      <div className="w-full max-w-3xl bg-white rounded-xl shadow p-6">
        {/* INTERVIEWER */}
        <div className="flex items-center gap-3 mb-6">
          <img
            src="https://randomuser.me/api/portraits/men/32.jpg"
            className="w-12 h-12 rounded-full"
            alt="Interviewer"
          />

          <div>
            <div className="font-semibold">Senior Software Engineer</div>
            <div className="text-sm text-gray-500">Technical Interviewer</div>
          </div>

          {isSpeaking && (
            <div className="ml-auto text-green-600 text-sm animate-pulse">
              Speaking...
            </div>
          )}
        </div>

        {/* CHAT */}
        <div className="h-72 overflow-y-auto border rounded-lg p-4 mb-4">
          {chatHistory.map((msg, i) => (
            <div key={i} className="mb-3">
              <div className="text-xs text-gray-500">
                {msg.role === "assistant" ? "Interviewer" : "You"}
              </div>
              <div className="bg-gray-100 rounded p-2">{msg.text}</div>
            </div>
          ))}
        </div>

        {/* USER INPUT */}
        <textarea
          placeholder="Speak or type your answer..."
          value={userAnswer}
          onChange={(e) => setUserAnswer(e.target.value)}
          className="w-full border rounded-lg p-3 mb-4"
        />

        <div className="flex gap-3">
          <button
            onClick={startRecording}
            className={`px-4 py-2 rounded-lg ${isRecording ? "bg-red-500 text-white" : "bg-gray-800 text-white"
              }`}
          >
            🎤 {isRecording ? "Listening..." : "Start Speaking"}
          </button>

          <button
            onClick={stopRecording}
            className="px-4 py-2 bg-gray-600 text-white rounded-lg"
          >
            Stop
          </button>

          <button
            onClick={submitAnswer}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg"
          >
            Submit
          </button>
        </div>
      </div>
      {showEndPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl text-center w-80">
            <h2 className="text-xl font-semibold mb-2">
              Interview Completed 🎉
            </h2>

            <p className="text-gray-600 mb-4">
              You’ve completed the interview.
              Click below to view your results.
            </p>

            <button
              onClick={() => navigate("/candidate/interview-results-hub", {
                state: { sessionId: sessionIdRef.current || sessionId }
              })}
              className="bg-blue-600 text-white px-5 py-2 rounded-lg"
            >
              View Results
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActiveInterviewSession;